import React, { useId } from "react";

function Logo({ className }) {
  const uid = useId().replace(/:/g, "");
  const gradId = `tt-grad-${uid}`;

  return (
    <span className={className ? `brand ${className}` : "brand"}>
      <span className="brand-mark" aria-hidden="true">
        <svg
          className="brand-mark-svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient
              id={gradId}
              x1="4"
              y1="6"
              x2="28"
              y2="26"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#7c3aed" />
              <stop offset="0.5" stopColor="#6366f1" />
              <stop offset="1" stopColor="#0ea5e9" />
            </linearGradient>
          </defs>
          {/* Code / JSX: </> */}
          <path
            d="M12 9 7 16 12 23M20 9l5 7-5 7"
            fill="none"
            stroke={`url(#${gradId})`}
            strokeWidth="2.35"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 7.5 14.5 24.5"
            fill="none"
            stroke={`url(#${gradId})`}
            strokeWidth="2.35"
            strokeLinecap="round"
          />
        </svg>
      </span>
      <span className="brand-text">
        <span className="brand-name">
          Tech<span className="brand-name-accent">Talent</span>
        </span>
      </span>
    </span>
  );
}

export default Logo;
